import { memo } from "react";
import { TextInput, List, Datagrid,
  TextField, EditButton, ShowButton,
  CreateButton, TopToolbar, ListProps } from "react-admin";
import { verifyAccess } from "../../utils/resourcePermissons";

const customersFilters = [
  <TextInput source="full_address" label="Address" variant="standard" alwaysOn/>,
];
const AddressCreateButton = memo((props: any) => {
  const path = `/addresses/create/${props.id}`
  return (
    <CreateButton to={{pathname: path, state: {id: props.id}}} label="Create address"/>
  )});
const ListActions = (props: ListProps) => (
  <TopToolbar>
    <AddressCreateButton {...props}/>
  </TopToolbar>
);
export const AddressList: React.FC<ListProps> = (props) => {
  return (
    <List {...props} filters={customersFilters} pagination={false} exporter={false} actions={<ListActions {...props}/>}>
      <Datagrid>
        <TextField source="id" label="ID"/>
        <TextField source="full_address" label="Address"/>
        <TextField source="city" label="City"/>
        <TextField source="state" label="State"/>
        <TextField source="zip" label="Zip"/>
        {verifyAccess(props.permissions, 'customer', 'update') ? <EditButton /> : null}
        <ShowButton />
      </Datagrid>
    </List>
  )};
